import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import { unwrapResult } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchContentByCategory,
  getTvContent
} from '../../../features/channels-collections/channelsCollectionsSlice';
import TvContentSlider from '../../components/channels/TvContentSlider/TvContentSlider';

const TvContentSliderLazyContainer = ({ genreId, title }) => {
  const { ref, inView } = useInView({ triggerOnce: true });
  const dispatch = useDispatch();

  const tvContent = useSelector(getTvContent);

  useEffect(() => {
    (async () => {
      try {
        if (!inView) return;
        unwrapResult(await dispatch(fetchContentByCategory(genreId)));
      } catch (e) {
        console.log(e);
      }
    })();
  }, [dispatch, genreId, inView]);

  if (tvContent[genreId] && tvContent[genreId].length === 0) return null;

  return (
    <div ref={ref}>
      <TvContentSlider
        items={tvContent[genreId]}
        heading={title}
        headingHref={`/tv-content/${genreId}`}
      />
    </div>
  );
};

export default TvContentSliderLazyContainer;

TvContentSliderLazyContainer.propTypes = {
  genreId: PropTypes.string,
  title: PropTypes.string.isRequired
};
